var CRUMINA = {};